<template>
  <CheckoutStep class="h-full">
    <template #header>
      <Stepper />
    </template>
    <template #aside>
      <div v-if="giftCard" class="flex flex-col gap-24">
        <GiftCardSummary
          :assetUrl="giftCard.designAsset.assetUrl"
          :price="giftCard.price"
        />

        <BillingAddressSummary :billing-address />
      </div>
    </template>

    <Payment
      :price="giftCard.price"
      :request-id="giftCard.requestId"
      @loaded="isPaymentLoading = false"
      @loading="handleStartLoading"
    />
    <RevLoadingScreen
      v-if="isPaymentLoading"
      class="bg-surface-default-mid fixed inset-0 z-10 w-full md:absolute md:right-[440px]"
      data-qa="loading-screen"
      :text="loadingMessage"
    />
  </CheckoutStep>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import CheckoutStep from '@backmarket/nuxt-layer-checkout/components/CheckoutStep/CheckoutStep.vue'
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'

import type { Bill } from '~/api/cart/types'

import GiftCardSummary from '../../components/GiftCardSummary/GiftCardSummary.vue'
import Stepper from '../../components/Stepper/Stepper.vue'

import BillingAddressSummary from './components/BillingAddressSummary/BillingAddressSummary.vue'
import Payment from './components/Payment/Payment.vue'

const isPaymentLoading = ref(false)
const loadingMessage = ref('')

defineProps<{
  giftCard: ApiSpecs['/api/gift-cards/v1/product-page/giftcard/request/:requestId']['GET']['response']
  billingAddress: Bill
}>()

const handleStartLoading = (message: string) => {
  loadingMessage.value = message
  isPaymentLoading.value = true
}
</script>
